import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-simple-description-info',
  templateUrl: './simple-description-info.component.html',
})
export class SimpleDescriptionInfoComponent {
  @Input() iconClass: string;
  @Input() title: string;
  @Input() description: string;
}
